import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useDispatch } from "react-redux";
import { Globals } from "utils/styleconfig";
import { RiCloseFill, RiEditBoxLine } from "react-icons/ri";
import Button from "components/UI/Button/Button";

import List from "components/List/List";
import utilityStyles from "styles/modules/Utility.module.scss";
import { useGetCallCenterAgentQuery } from "features/call_center/callCenterApiSlice";
import UpdateCenterAgent from "../UpdateCenterAgent/UpdateCenterAgent";

const ViewCenterAgent = ({ label }) => {
  const params = useParams();

  const dispatch = useDispatch();

  const [isEditVisible, setEditVisible] = useState(false);

  useEffect(() => {
    dispatch(setNavbarTitle("View Call Center Agent"));
  }, [dispatch]);

  const { data: callAgent } = useGetCallCenterAgentQuery(params?.id);

  const toggleEditVisibility = () => {
    setEditVisible(!isEditVisible);
  };

  const extensionData = [
    { label: "Name", value: callAgent?.name },
    { label: "Type", value: callAgent?.type },
    { label: "Contact", value: callAgent?.contact },
    { label: "Status", value: callAgent?.status },
    { label: "No. Answer Delay Time", value: callAgent?.no_answer_delay_time },
    { label: "Max Answer No.", value: callAgent?.max_no_answer },
    { label: "Wrap Up Time", value: callAgent?.wrap_up_time },
    { label: "Reject Delay Time", value: callAgent?.reject_delay_time },
    { label: "Busy Delay Time", value: callAgent?.busy_delay_time },
    { label: "Enabled", value: callAgent?.enabled ? 'Yes' : 'No' },
    { label: "Domain", value: callAgent?.domain?.name || "" },
    { label: "User", value: `${callAgent?.user?.firstname} ${callAgent?.user.lastname}` },
  ];

  return (
    <>
      <div className={`${utilityStyles.grid} ${utilityStyles.grid_col2} ${utilityStyles.gap10}`}>
        <div className={`${utilityStyles.flexColumn} ${utilityStyles.justifyStart} ${utilityStyles.gap10} ${utilityStyles.colorWhite} ${utilityStyles.dataList} `} >
          <List customStyle={`${utilityStyles.grid} ${utilityStyles.gap10}`} data={extensionData} />
          <div>
            {/* Button to toggle visibility */}
            <Button onClick={toggleEditVisibility} className={`${utilityStyles.btn}`}>
              {isEditVisible ? (
                <RiCloseFill color={Globals.colorRed} size={30} />
              ) : (
                <>
                  <h3>Edit Call Center Agents </h3>
                  <RiEditBoxLine color={Globals.colorDarkBlue} size={20} />
                </>
              )}
            </Button>
          </div>
        </div>
      </div>

      {/* {isEditVisible && (
        <UpdateCenterAgent label={label} />
      )} */}
    </>
  )
}

export default ViewCenterAgent